import { InputHTMLAttributes, useId, ReactNode } from "react";
import Label from "./Label";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  children: ReactNode;
}

export default function Radio({ children, ...rest }: Props) {
  const inputId = useId();

  return (
    <>
      <input
        {...rest}
        id={inputId}
        type="radio"
        className="checked:bg-radio-checked me-1 mt-1 size-4 appearance-none rounded-full border border-zinc-200 bg-white bg-contain bg-center bg-no-repeat align-top checked:border-blue-600 checked:bg-blue-600 disabled:pointer-events-none disabled:opacity-50 disabled:filter-none dark:border-zinc-600 dark:bg-neutral-800"
      />
      <Label htmlFor={inputId} disabled={rest.disabled}>
        {children}
      </Label>
    </>
  );
}
